<ng-container *transloco="let t">
    <span #focusTarget tabindex="-1" aria-hidden="true"></span>
    <form [formGroup]="forgotPasswordForm" class="forgot-password-container" (ngSubmit)="onSubmit()">
        @if(allErrors?.length){
        <div class="generic-errors">
            @for (error of allErrors; track $index) {
            <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{error}}.</span>
            }
        </div>
        }
        <div class="form-container">
            <p class="email-header">{{t("modals.forgot_password_modal.enter_email")}}</p>
            <div class="input-wrapper">
                <cwo-input formControlName="email" [type]="'email'" [placeholder]="'Email'" [required]="true"
                    [invalid]="showEmailError && email.invalid" />
                <div class="errors-wrapper">
                    @if(showEmailError && email.invalid){
                    @if(email.hasError('required')){
                    <span class="input-error"><cwo-icon class="icon"
                            [name]="iconNameType.error"></cwo-icon>{{t("modals.forgot_password_modal.email_required")}}.</span>
                    }
                    @if(email.hasError('email')){
                    <span class="input-error"><cwo-icon class="icon"
                            [name]="iconNameType.error"></cwo-icon>{{t("modals.forgot_password_modal.email_invalid")}}.</span>
                    }
                    }
                </div>
            </div>
        </div>
        <button [type]="'submit'" cwoAsyncButton [subscription]="loadingSubscription" class="button-accent submit-button" cwoAsyncButton [ariaLabel]="'Submit Button'">
            {{t("modals.forgot_password_modal.submit")}}
        </button>
        <button type="button" class="back-button" (click)="onBackToSignInClicked()">
            <cwo-icon class="icon" [name]="iconNameType.arrow" style="transform: rotate(90deg);" />
            {{t("modals.forgot_password_modal.back_to_sign")}}
        </button>
    </form>
</ng-container>